import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { AnimatedSpinner } from '../../../../components/AnimatedSpinner'
import { AvatarDisplay } from './AvatarDisplay'

interface WaitingForApprovalStateProps {
  shouldShowAvatar: boolean
  isLoading: boolean
  companion: {
    avatarId: string
    mentorId: string
    slug: string
  }
  onPublish: () => void
  onRestart: () => void
  isApproving: boolean
  isDeleting: boolean
}

const WaitingForApprovalState: React.FC<WaitingForApprovalStateProps> = memo(
  ({
    shouldShowAvatar,
    isLoading,
    companion,
    onPublish,
    onRestart,
    isApproving,
    isDeleting,
  }) => {
    const { t } = useTranslation()
    if (shouldShowAvatar && !isLoading) {
      return (
        <AvatarDisplay
          avatarId={companion.avatarId}
          mentorId={companion.mentorId}
          slug={companion.slug}
          onPublish={onPublish}
          onRestart={onRestart}
          isPublishing={isApproving}
          isDeleting={isDeleting}
        />
      )
    }

    return (
      <div className="h-full flex flex-col items-center justify-center px-0 sm:px-4 pt-4 sm:pt-10 mb-auto sm:mb-0">
        <div className="shrink-0 h-12 w-12 rounded-full bg-dark-neutral-500 text-white flex items-center justify-center mb-8">
          <AnimatedSpinner />
        </div>
        <p className="text-center text-dark-neutral-200 text-lg">
          {t('twin.loadingTwinData')}
        </p>
      </div>
    )
  },
)

export { WaitingForApprovalState }
